"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = void 0;
var react_1 = require("@emotion/react");
var style_1 = require("../../style");
var variables_1 = require("../../style/variables");
var SIZE = {
    'default': 32,
    'small': 24,
};
var createStyles = function (_a) {
    var color = _a.color;
    return ({
        stepContainer: function (showHover) { return react_1.css({
            flex: 1,
            position: 'relative',
            cursor: 'pointer',
            width: '100%',
            '&:hover': __assign({ '.label': {
                    color: color.PRIMARY.DARK_1,
                } }, (showHover ? {
                '.stepper-icon': {
                    backgroundColor: "var(" + variables_1.ThemeColor.Gray.LIGHT_5 + ")",
                    borderColor: "var(" + variables_1.ThemeColor.Gray.DEFAULT + ")",
                    color: "var(" + variables_1.ThemeColor.Gray.DEFAULT + ")",
                },
            } : {})),
        }); },
        stepDisabled: function (disabled) { return react_1.css({
            pointerEvents: disabled ? 'none' : 'auto',
            // opacity: disabled ? 0.5 : 1,
            '.label': {
                color: disabled ? color.GRAY.LIGHT_1 : '',
            },
            '.subLabel': {
                color: disabled ? color.GRAY.LIGHT_1 : '',
            },
            '.stepper-icon': {
                backgroundColor: disabled ? "var(" + variables_1.ThemeColor.Gray.LIGHT_6 + ")" : '',
                borderColor: disabled ? "var(" + variables_1.ThemeColor.Gray.LIGHT_2 + ")" : '',
            },
            'svg': {
                color: disabled ? "var(" + variables_1.ThemeColor.Gray.LIGHT_2 + ")" : '',
            },
        }); },
        stepCardContainer: function (isCurrentStep) { return react_1.css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: style_1.pxToRem(16, 16),
            borderRadius: style_1.pxToRem(8, 16),
            width: style_1.pxToRem(400, 16),
            background: isCurrentStep ? color.PRIMARY.LIGHT_5 : 'white',
            borderColor: isCurrentStep ? color.PRIMARY.DEFAULT : color.GRAY.LIGHT_3,
            margin: 0,
            marginBottom: style_1.pxToRem(8, 16),
            ':hover': {
                borderColor: color.PRIMARY.DEFAULT,
            },
        }); },
        disabled: function (disabled) { return react_1.css({
            background: disabled ? color.GRAY.LIGHT_5 : '',
        }); },
        stepConnector: function (size) { return react_1.css({
            position: 'absolute',
            top: style_1.pxToRem(SIZE[size] / 2 - 1, 16),
            left: "calc(-50% + " + SIZE[size] / 2 + "px)",
            right: "calc(50% + " + SIZE[size] / 2 + "px)",
            borderColor: color.GRAY.LIGHT_2,
            borderTopStyle: 'solid',
            borderTopWidth: style_1.pxToRem(2, 16),
        }); },
        stepVerticalConnector: function (size) { return react_1.css({
            borderColor: color.GRAY.LIGHT_2,
            borderLeftStyle: 'solid',
            borderLeftWidth: style_1.pxToRem(2, 16),
            marginLeft: style_1.pxToRem(SIZE[size] / 2 - 1, 16),
            paddingLeft: style_1.pxToRem(SIZE[size], 16),
            marginTop: 4,
            marginBottom: 4,
        }); },
        stepVerticalConnectorHide: function (hide) { return react_1.css({
            borderColor: hide ? 'transparent' : '',
        }); },
        label: function (isCurrentStep) { return react_1.css({
            fontWeight: 600,
            fontSize: style_1.pxToRem(14, 16),
            color: isCurrentStep ? color.PRIMARY.DARK_1 : color.GRAY.DARK_4,
            marginTop: style_1.pxToRem(14, 16),
        }); },
        verticalLabel: function (size) { return react_1.css({
            marginTop: 0,
            marginLeft: style_1.pxToRem(size === 'small' ? 12 : 16, 16),
        }); },
        verticalCardLabel: react_1.css({
            marginTop: 0,
        }),
        subLabel: function (isCurrentStep) { return react_1.css({
            marginTop: style_1.pxToRem(4, 16),
            fontWeight: 400,
            fontSize: style_1.pxToRem(14, 16),
            color: isCurrentStep ? color.PRIMARY.DARK_1 : color.GRAY.DEFAULT,
            textAlign: 'center',
        }); },
        verticalSubLabel: react_1.css({
            textAlign: 'left',
            minHeight: style_1.pxToRem(40, 16),
        }),
        verticalCardSubLabel: react_1.css({
            textAlign: 'left',
        }),
        iconBasic: function (size) { return react_1.css({
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '50%',
            width: style_1.pxToRem(SIZE[size], 16),
            height: style_1.pxToRem(SIZE[size], 16),
            borderWidth: style_1.pxToRem(2, 16),
            borderStyle: 'solid',
            borderColor: "var(" + variables_1.ThemeColor.Gray.LIGHT_2 + ")",
            color: "var(" + variables_1.ThemeColor.Gray.LIGHT_2 + ")",
            cursor: 'pointer',
        }); },
        icon: function (isCurrentStep) { return react_1.css({
            borderColor: isCurrentStep ? color.PRIMARY.DARK_1 : '',
            backgroundColor: isCurrentStep ? color.PRIMARY.LIGHT_5 : '',
            color: isCurrentStep ? color.PRIMARY.DARK_1 : '',
        }); },
        iconCompleted: function (isCompleted) { return react_1.css({
            borderColor: isCompleted ? color.SUCCESS.DEFAULT : '',
            backgroundColor: isCompleted ? color.SUCCESS.LIGHT_5 : '',
            color: isCompleted ? color.SUCCESS.DEFAULT : '',
        }); },
        layerIcon: function (disabled) { return react_1.css({
            height: style_1.pxToRem(32, 16),
            width: style_1.pxToRem(32, 16),
            padding: style_1.pxToRem(7, 16),
            borderRadius: '50%',
            background: disabled ? color.GRAY.LIGHT_4 : color.PRIMARY.LIGHT_4,
            color: disabled ? color.GRAY.DARK_1 : color.PRIMARY.DARK_1,
            marginRight: style_1.pxToRem(16, 16),
        }); },
        cardLabelContainer: react_1.css({
            marginRight: style_1.pxToRem(16, 16),
            flex: 1,
        }),
        flex1: react_1.css({
            flex: 1,
        }),
    });
};
exports.createStyles = createStyles;
